module.exports = __webpack_public_path__ + "img/opening.d9be6ac1.jpg";